(() => {
  const header = document.getElementById('header');
  const burger = document.getElementById('burger');
  const drawer = document.getElementById('drawer');
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine = matchMedia('(pointer: fine)').matches;

  // Masaüstünde yumuşak kaydırma
  let lenis = null;
  if (!reduce && fine && window.Lenis) {
    lenis = new Lenis({ lerp: 0.085, wheelMultiplier: 0.9, smoothWheel: true });
    window.__lenis = lenis;
    const raf = (t) => { lenis.raf(t); requestAnimationFrame(raf); };
    requestAnimationFrame(raf);
    document.querySelectorAll('a[href*="#"]').forEach((a) => a.addEventListener('click', (e) => {
      const url = new URL(a.href, location.href);
      if (url.pathname !== location.pathname || !url.hash) return;
      const el = document.querySelector(url.hash);
      if (el) { e.preventDefault(); lenis.scrollTo(el, { offset: -80 }); }
    }));
  }

  // Hero başlığı kelime kelime
  document.querySelectorAll('.split').forEach((el) => {
    const words = el.innerHTML.split(/(\s+|<br\s*\/?>)/i);
    let i = 0;
    el.innerHTML = words.map((w) => {
      if (!w.trim() || /^<br/i.test(w)) return w;
      return `<span class="w"><span style="--i:${i++}">${w}</span></span>`;
    }).join('');
  });

  // Kaydırdıkça aydınlanan cümleler
  const wordBlocks = [...document.querySelectorAll('[data-words]')].map((el) => {
    const once = el.dataset.words === 'once';
    el.innerHTML = el.textContent.trim().split(/\s+/).map((w) => `<span class="mw">${w}</span>`).join(' ');
    const words = [...el.querySelectorAll('.mw')];
    if (once) {
      words.forEach((w, i) => { w.style.transitionDelay = (i * 70) + 'ms'; w.style.transitionDuration = '.6s'; });
      new IntersectionObserver(([e], o) => { if (e.isIntersecting) { words.forEach((w) => w.classList.add('on')); o.disconnect(); } }, { threshold: 0.4 }).observe(el);
      return null;
    }
    return { el, words };
  }).filter(Boolean);

  // Açılış perdesi: tıklayınca geç, bitince DOM'dan çekil
  const veil = document.getElementById('veil');
  if (veil && document.documentElement.classList.contains('intro')) {
    const done = () => veil.classList.add('is-done');
    veil.addEventListener('click', () => { veil.classList.add('is-skip'); setTimeout(done, 650); });
    setTimeout(done, 3400);
  }

  // Bölüm içerikleri de sırayla, yumuşakça belirsin
  ['.sec__head', '.layer', '.layers__text > *', '.steps li', '.faq h2', '.faq details', '.stat', '.trust li', '.custom > div:last-child > h2', '.custom .btns']
    .forEach((sel) => document.querySelectorAll(sel).forEach((el) => {
      if (el.closest('.rv') || el.querySelector('.rv')) return;
      const i = [...el.parentElement.children].indexOf(el);
      el.classList.add('rv');
      el.style.setProperty('--d', Math.min(i * 0.08, 0.4) + 's');
    }));

  // Derinlik için hafif kaydırma farkı
  const parEls = [...document.querySelectorAll('.feel__img img, .layers__media video, .custom__img img, .story__media img')];
  parEls.forEach((el) => { el.dataset.par = el.closest('.feel') ? '0.07' : '0.05'; });

  // Görsel ve bölüm belirmesi
  const rvObs = new IntersectionObserver((entries) => {
    entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('in'); rvObs.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });
  document.querySelectorAll('.rv').forEach((el) => rvObs.observe(el));

  // Sayaçlar
  const cObs = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (!e.isIntersecting) return;
      cObs.unobserve(e.target);
      const el = e.target, to = parseInt(el.dataset.to, 10) || 0;
      if (reduce || to === 0) { el.textContent = to; return; }
      const from = to > 1000 ? to - 40 : 0, t0 = performance.now(), dur = 1600;
      const tick = (t) => {
        const k = Math.min(1, (t - t0) / dur), ease = 1 - Math.pow(1 - k, 3);
        el.textContent = Math.round(from + (to - from) * ease);
        if (k < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    });
  }, { threshold: 0.6 });
  document.querySelectorAll('.count').forEach((el) => cObs.observe(el));

  // Videolar yalnızca görünürken oynar
  const vObs = new IntersectionObserver((entries) => {
    entries.forEach((e) => { if (e.isIntersecting) e.target.play().catch(() => {}); else e.target.pause(); });
  }, { threshold: 0.15 });
  document.querySelectorAll('.lazy-video').forEach((v) => vObs.observe(v));

  // Sinematik sahne: film kaydırdıkça çerçeveye çekilir, başlık süzülür, söz belirir
  const cine = document.querySelector('[data-cine]');
  const smooth = (a, b, x) => { const t = Math.min(1, Math.max(0, (x - a) / (b - a))); return t * t * (3 - 2 * t); };
  let cineCur = 0, cineTarget = 0, cineRaf = 0, cineP = 0;
  const cinePaint = () => {
    // Lenis zaten yumuşatıyor; dokunmatikte kendi yumuşatmamızı ekliyoruz
    cineCur += (cineTarget - cineCur) * (lenis ? 1 : 0.16);
    if (Math.abs(cineTarget - cineCur) < 0.0005) cineCur = cineTarget;
    const p = cineCur;
    cine.style.setProperty('--f', smooth(0.08, 1, p).toFixed(4));
    cine.style.setProperty('--o', smooth(0, 0.36, p).toFixed(4));
    cine.style.setProperty('--s', smooth(0.4, 0.74, p).toFixed(4));
    cineRaf = cineCur !== cineTarget ? requestAnimationFrame(cinePaint) : 0;
  };
  if (cine) {
    const film = cine.querySelector('video');
    if (film) new IntersectionObserver(([e]) => { e.isIntersecting ? film.play().catch(() => {}) : film.pause(); }).observe(cine);
  }

  // Filmler ekrana yaklaşınca yüklenir, görünürken oynar
  const lazyFilms = [...document.querySelectorAll('video[data-lazy]')];
  const filmObs = new IntersectionObserver((entries) => entries.forEach(({ target: v, isIntersecting: on }) => {
    if (on && !v.dataset.loaded) { v.querySelectorAll('source[data-src]').forEach((s) => { s.src = s.dataset.src; }); v.load(); v.dataset.loaded = '1'; }
    if (on && !v.dataset.userPaused && !reduce) v.play().catch(() => {}); else if (!on) v.pause();
  }), { rootMargin: '300px 0px' });
  lazyFilms.forEach((v) => filmObs.observe(v));

  // Adımlı bölümler: pin → bölüm boyunca ilerleme, center → ekran ortasındaki madde
  const stepSecs = [...document.querySelectorAll('[data-steps]')].map((el) => {
    const steps = [...el.querySelectorAll('[data-step]')];
    el.style.setProperty('--steps', steps.length);
    return { el, mode: el.dataset.steps, steps, dots: [...el.querySelectorAll('[data-step-dot]')], media: [...el.querySelectorAll('[data-step-media]')], num: el.querySelector('[data-step-num]'), navs: [...el.querySelectorAll('[data-goto]')], cur: -1 };
  });
  const setStep = (s, i) => {
    if (s.cur === i) return;
    s.cur = i;
    [s.steps, s.dots, s.media, s.navs].forEach((list) => list.forEach((n, k) => { n.classList.toggle('is-on', k === i); n.classList.toggle('is-past', k < i); }));
    s.el.style.setProperty('--i', i);
    if (s.num) s.num.textContent = String(i + 1).padStart(2, '0');  };
  stepSecs.forEach((s) => {
    setStep(s, 0);
    // Teslimat menüsü: tıklanan adıma kaydır
    s.navs.forEach((b) => b.addEventListener('click', () => {
      const k = +b.dataset.goto, n = s.steps.length, top = s.el.getBoundingClientRect().top + scrollY;
      const y = top + (s.el.offsetHeight - innerHeight) * ((k + 0.5) / n);
      lenis ? lenis.scrollTo(y, { duration: 1.6 }) : scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
    }));
  });
  const paintSteps = (vh) => stepSecs.forEach((s) => {
    const r = s.el.getBoundingClientRect();
    if (r.bottom < 0 || r.top > vh) return;
    const n = s.steps.length;
    if (s.mode === 'pin') {
      const p = Math.min(1, Math.max(0, -r.top / Math.max(1, r.height - vh)));
      s.el.style.setProperty('--p', p.toFixed(4));
      setStep(s, Math.min(n - 1, Math.floor(p * n)));
    } else {
      let best = 0, bd = Infinity;
      s.steps.forEach((st, k) => { const q = st.getBoundingClientRect(), d = Math.abs(q.top + q.height / 2 - vh / 2); if (d < bd) { bd = d; best = k; } });
      setStep(s, best);
    }
  });

  // Satın alma vitrini: masaüstünde dikey kaydırma yatay akışa dönüşür
  const hs = document.querySelector('[data-hscroll]');
  const hTrack = hs && hs.querySelector('[data-track]');
  const hBar = hs && hs.querySelector('[data-hbar]');
  let hDist = 0;
  const hLayout = () => {
    if (!hs) return;
    const pin = !reduce && matchMedia('(min-width: 1101px)').matches;
    hs.classList.toggle('is-pinned', pin);
    hDist = pin ? Math.max(0, hTrack.scrollWidth - innerWidth + parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--gut') || 40) * 2) : 0;
    hs.style.height = pin ? `${innerHeight + hDist}px` : '';
    if (!pin) hTrack.style.transform = '';
  };
  const paintH = (vh) => {
    if (!hDist) return;
    const r = hs.getBoundingClientRect();
    if (r.bottom < 0 || r.top > vh) return;
    const p = Math.min(1, Math.max(0, -r.top / hDist));
    hTrack.style.transform = `translate3d(${(-p * hDist).toFixed(1)}px,0,0)`;
    if (hBar) hBar.style.setProperty('--h', p.toFixed(4));
  };
  hLayout();
  addEventListener('resize', () => { hLayout(); onFrame(); });

  // Sayfa tonu: ekranın ortasındaki bölüm kum zeminliyse tüm zemin yavaşça kuma döner
  const tones = document.body.classList.contains('template-index') ? [...document.querySelectorAll('.sec--kum')] : [];
  const progress = document.getElementById('progress');

  // Tek kaydırma döngüsü: header, sahne, ton, derinlik, kelime aydınlatma
  let lastY = scrollY, ticking = false;
  const onFrame = () => {
    const y = scrollY, vh = innerHeight;
    header.classList.toggle('is-scrolled', y > 10);
    if (!drawer.classList.contains('is-open')) header.classList.toggle('is-hidden', y > lastY && y > 400);
    lastY = y;
    if (progress) progress.style.transform = `scaleX(${(y / Math.max(1, document.documentElement.scrollHeight - vh)).toFixed(4)})`;
    if (cine) {
      const r = cine.getBoundingClientRect();
      cineP = Math.min(1, Math.max(0, -r.top / Math.max(1, r.height - vh)));
      header.classList.toggle('is-over', r.bottom > 0 && cineP < 0.3 && !drawer.classList.contains('is-open'));
      if (!reduce) { cineTarget = cineP; if (!cineRaf) cineRaf = requestAnimationFrame(cinePaint); }
    }
    paintSteps(vh);
    paintH(vh);
    if (tones.length) {
      const mid = vh * 0.5;
      const on = tones.some((el) => { const r = el.getBoundingClientRect(); return r.top < mid && r.bottom > mid; });
      if ((document.body.dataset.tone === 'kum') !== on) document.body.dataset.tone = on ? 'kum' : '';
    }
    if (!reduce) parEls.forEach((el) => {
      const r = el.parentElement.getBoundingClientRect();
      if (r.bottom < -100 || r.top > vh + 100) return;
      const off = (r.top + r.height / 2 - vh / 2) * parseFloat(el.dataset.par);
      el.style.setProperty('--py', (-off).toFixed(1) + 'px');
    });
    wordBlocks.forEach(({ el, words }) => {
      const r = el.getBoundingClientRect();
      if (r.bottom < 0 || r.top > vh) return;
      const p = Math.min(1, Math.max(0, (vh * 0.85 - r.top) / (r.height + vh * 0.35)));
      const lit = Math.round(p * words.length);
      words.forEach((w, i) => w.classList.toggle('on', reduce || i < lit));
    });
    ticking = false;
  };
  addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(onFrame); } }, { passive: true });
  onFrame();

  // Mobil menü
  const toggle = (open) => {
    burger.setAttribute('aria-expanded', open);
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', !open);
    if (open) header.classList.remove('is-over');
    document.body.style.overflow = open ? 'hidden' : '';
    if (lenis) open ? lenis.stop() : lenis.start();
  };
  burger.addEventListener('click', () => toggle(burger.getAttribute('aria-expanded') !== 'true'));
  drawer.addEventListener('click', (e) => { if (e.target.closest('a')) toggle(false); });
  addEventListener('keydown', (e) => { if (e.key === 'Escape' && drawer.classList.contains('is-open')) { toggle(false); burger.focus(); } });

  // WhatsApp balonu
  const wa = document.getElementById('wa');
  if (wa) {
    setTimeout(() => wa.classList.add('is-on'), 1200);
    let shown = false;
    try { shown = sessionStorage.getItem('waTip') === '1'; } catch (e) {}
    if (!shown) {
      setTimeout(() => wa.classList.add('tip-on'), 3500);
      setTimeout(() => wa.classList.remove('tip-on'), 9500);
      try { sessionStorage.setItem('waTip', '1'); } catch (e) {}
    }
  }

  // Yasal sayfa içindekiler
  const toc = [...document.querySelectorAll('.legal__toc a')];
  if (toc.length) {
    const tObs = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) toc.forEach((a) => a.classList.toggle('is-active', a.hash === '#' + e.target.id)); });
    }, { rootMargin: '-30% 0px -60% 0px' });
    document.querySelectorAll('.legal__item').forEach((el) => tObs.observe(el));
  }
})();
